import { Modal, Button, Form } from 'react-bootstrap';

const SaveSearchModal = ({ saveSearchShowModal, handleCloseSaveSearch, saveSearchName, setSaveSearchName, handleSubmitSaveSearchData, saveSearchErrorMessage, setSaveSearchErrorMessage }) => {

    return (
        <Modal show={saveSearchShowModal} onHide={handleCloseSaveSearch} centered className='saved-search-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Save Search</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId="searchName">
                    <Form.Label>Search Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter search name"
                        value={saveSearchName}
                        onChange={(e) => {
                            setSaveSearchName(e.target.value);
                            setSaveSearchErrorMessage('');
                        }}
                    />
                    {saveSearchErrorMessage && <div className="text-danger">{saveSearchErrorMessage}</div>}
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseSaveSearch}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmitSaveSearchData}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SaveSearchModal;
